
import { services } from '../../../mocks/services';

export default function Services() {
  return (
    <section id="services" className="py-24 px-6 bg-gray-50">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col md:flex-row justify-between items-start mb-16">
          <h2 className="text-5xl font-serif font-bold text-gray-900 mb-4 md:mb-0">
            What We<br />Create
          </h2>
          <p className="text-lg text-gray-600 max-w-md">
            From concept to completion, we offer comprehensive design services tailored to bring your vision to life.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {services.map((service, index) => (
            <div
              key={index}
              className={`rounded-3xl p-8 transition-all duration-300 hover:-translate-y-2 hover:shadow-2xl cursor-pointer ${
                index === 0
                  ? 'bg-gray-900 text-white lg:col-span-1'
                  : 'bg-white text-gray-900 shadow-lg'
              }`}
            >
              {index !== 0 && service.badge && (
                <div className="inline-flex items-center space-x-2 px-3 py-1 bg-teal-100 rounded-full mb-6">
                  <i className={`${service.badge.icon} text-teal-600 text-sm`}></i>
                  <span className="text-xs font-medium text-teal-700">{service.badge.text}</span>
                </div>
              )}
              
              <div className="mb-6">
                <div className={`w-16 h-16 rounded-2xl flex items-center justify-center mb-6 ${
                  index === 0 ? 'bg-white/10' : 'bg-teal-50'
                }`}>
                  <i className={`${service.icon} text-3xl ${index === 0 ? 'text-white' : 'text-teal-600'}`}></i>
                </div>
                <h3 className={`text-2xl font-bold mb-3 ${index === 0 ? 'text-white' : 'text-gray-900'}`}>
                  {service.title}
                </h3>
                <p className={`leading-relaxed ${index === 0 ? 'text-white/80' : 'text-gray-600'}`}>
                  {service.description}
                </p>
              </div>

              <button
                className={`w-full py-3 rounded-full font-medium transition-colors whitespace-nowrap ${
                  index === 0
                    ? 'border-2 border-white text-white hover:bg-white hover:text-gray-900'
                    : 'bg-gray-900 text-white hover:bg-gray-800'
                }`}
              >
                Learn More
              </button>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}